import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'
import {useReportWidgetSeen} from '~/hooks/analytic-hooks'
import {AmazonLocalizedLogo} from '~/icons/icon-amazon-logo-by-locale'
import {CheckBadge} from '~/icons/product-page/check-badge'

const TrustBar = () => {
  const {locale, language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'trust-bar',
    widget_place: 'middle',
  })

  return (
    <div ref={widgetRef}>
      <div className="border-gray align-center relative z-20 flex h-full w-full items-center justify-center gap-2 rounded-2xl border bg-white p-2 shadow transition-all duration-200 ease-in-out">
        <AmazonLocalizedLogo locale={locale?.toLowerCase()} className="h-8" />
        <CheckBadge fill="#22C55E" className="ml-4 h-4" />
        <p className="text-base leading-none">{translations.ReviewsAnalyzed(45_000, language)}</p>
      </div>
    </div>
  )
}

export default TrustBar
